<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="cancel()" />
</div>

<ion-content>
  <ion-title class="smaller">
    <h1>Ladehistorikk</h1>
  </ion-title>
  <ion-grid>
    @if (isLoading) {
    <ion-row>
      <ion-col>
        <ion-spinner name="crescent"></ion-spinner>
      </ion-col>
    </ion-row>
    }
    <ion-row>
      <ion-col>
        @if (!isLoading) {
        <div class="my-3">
          <span (click)="showHideCal()" class="month-selector">
            <ion-icon name="calendar"></ion-icon>&nbsp;{{
              this.selectedMonth | date : 'MMMM yyyy' : '' : 'nb' | titlecase
            }}
          </span>
        </div>
        }
        <div
          class="datepicker-popup"
          [style.display]="showMonthCal ? 'inline-block' : 'none'"
          id="airEnodeMonth"
        ></div>
      </ion-col>
    </ion-row>
    @if (!isLoading) {
    <ion-row>
      <ion-col>
        <p class="smalltext">
          Denne måneden estimerer vi følgende beløp for fullførte ladeplaner,
          med forbehold om feil:
        </p>
        <div class="total-sum">
          <p>Total besparelse</p>
          <p>{{ formatLocaleNumber(totalSavings) }} kr</p>
        </div>
        <div class="total-sum">
          <p>Total ladekostnad</p>
          <p>{{ formatLocaleNumber(totalCost) }} kr</p>
        </div>
        <!-- <div class="total-sum">
          <p>Totalt ladeforbruk</p>
          <p>{{ 'TBA' }} kWh</p>
        </div> -->
      </ion-col>
    </ion-row>
    } @if (!isLoading) {
    <ion-row class="plans">
      <ion-col>
        <div *ngFor="let day of plansByDay">
          <p class="bold cap-first">{{ day.date }}</p>

          <div *ngFor="let plan of day.plans" class="plan">
            <div
              class="plan-header"
              [class.collapsed]="!plansExpandedState[plan.id]"
              (click)="toggleIsPlanExpanded(plan)"
            >
              <p class="left">{{ plan.finalStateText }}</p>
              <p class="right flex-align">
                <span>
                  <img
                    class="chevron"
                    [class.open-chevron]="plansExpandedState[plan.id]"
                    src="/assets/img/shared/chevron.svg"
                  />
                </span>
              </p>
            </div>
            @if (plansExpandedState[plan.id]) {
            <div class="plan-content">
              @if (!didFinish(plan) || didFinishWithError(plan)) {
              <div>
                <p class="left">
                  {{ plan.unfinishedReasonText }}
                </p>
              </div>
              }
              <table class="plan-table">
                <tr>
                  <td>
                    <p class="left">Planens tidsfrist</p>
                  </td>
                  <td>
                    <p class="right">
                      {{ plan.deadlineText }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="left">Lading startet</p>
                  </td>
                  <td>
                    <p class="right">
                      {{ plan.startText }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="left">
                      {{
                        plan.wasUnplugged ? 'Lader frakoblet' : 'Lading ferdig'
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="right">
                      {{ plan.endText }}
                    </p>
                  </td>
                </tr>
                @if (plan.startConfirmedAt) {
                <tr>
                  <td>
                    <p class="left">Ladetid</p>
                  </td>
                  <td>
                    <p class="right">
                      {{ plan.chargeDurationText }}
                    </p>
                  </td>
                </tr>
                }
                <tr>
                  <td>
                    <p class="left"><strong>Detaljer</strong></p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="left">
                      <!-- Vi anslår du sparte -->
                      Besparelse
                      <ion-icon
                        name="help-circle-outline"
                        class="help-icon"
                        (click)="openHelpCost()"
                      ></ion-icon>
                    </p>
                  </td>
                  <td>
                    <p class="right">{{ plan.savingsText }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="left">Ladekostnad</p>
                  </td>
                  <td>
                    <p class="right">{{ plan.costText }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="left">Ladeforbruk</p>
                  </td>
                  <td>
                    <p class="right">{{ plan.usageKwText }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="left">Snittspris ladeøkt</p>
                  </td>
                  <td>
                    <p class="right">{{ plan.meanPriceText }}</p>
                  </td>
                </tr>
              </table>
              <p class="left">
                <small
                  >Detaljene for planen er estimerte. Vi tar forbehold om
                  feil.</small
                >
              </p>
              @if(plan.overriddenText) {
              <div>
                <p class="left">{{ plan.overriddenText }}</p>
              </div>
              }
            </div>
            }
          </div>
        </div>
      </ion-col> </ion-row
    >}
  </ion-grid>
</ion-content>
